// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import clearForm from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/ClearForm";
import submitContactForm from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
// import Button, { ButtonPresentationProps } from "@insite/mobius/Button"; bunzl custom code
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
// import React, { useState } from "react"; // Starter Custom Code
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code */
import FormActions, { FormActionsStyles } from "@store/Library/Components/Toolkit/FormActions";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import constants from "@toolkit/Framework/Common/GoogleAnalytics/constants";
import React, { RefObject, useEffect, useMemo, useRef, useState } from "react";
/* Starter Custom Code */

/* Foundation */
import FormWrapper from "@store/Library/Components/Toolkit/FormWrapper";
/* Foundation */

/* Store Custom Code - Start */
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import { useToaster } from "@insite/mobius/Toast/ToasterContext";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import getButtonSizeVariantField from "@store/Framework/Common/Fields/Toolkit/buttonSizeVariant";
import getButtonVariantField from "@store/Framework/Common/Fields/Toolkit/buttonVariant";
import Button, { ButtonPresentationProps, ButtonSizeVariants } from "@store/MobiusOverrides/Button/Button";
import { useGetLink } from "@store/Framework/Store/Links/LinksSelectors";
import ReCAPTCHA from "react-google-recaptcha";
/* Store Custom Code - End */

const enum fields {
    emailRecipients = "emailRecipients",
    submitButtonText = "submitButtonText",
    successMessage = "successMessage",
    // Store Custom Code - >
    successMessageType = "successMessageType",
    variant = "variant",
    sizeVariant = "sizeVariant",
    buttonAlignment = "buttonAlignment",
    link = "link",
}

/* Store Custom Code - Start */
const variantField = getButtonVariantField(fields.variant);
const sizeVariantField = getButtonSizeVariantField(fields.sizeVariant);
/* Store Custom Code - End */

interface OwnProps extends WidgetProps {
    fields: {
        [fields.emailRecipients]: string;
        [fields.submitButtonText]: string;
        [fields.successMessage]: string;
        // Store Custom Code - >
        [fields.successMessageType]: "modal" | "toast";
        [fields.variant]: "primary" | "secondary" | "tertiary";
        [fields.sizeVariant]: ButtonSizeVariants;
        [fields.link]: LinkFieldValue;
        [fields.buttonAlignment]: "flex-start" | "center" | "flex-end";
        // Store Custom Code
    };
}

const mapDispatchToProps = {
    submitContactForm,
    clearForm,
    validateReCaptcha: makeHandlerChainAwaitable<{ location: string; recaptchaRef: RefObject<ReCAPTCHA> }, boolean>(
        validateReCaptcha,
    ),
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export interface ContactFormStyles {
    container?: GridContainerProps;
    formGridItem?: GridItemProps;
    submitButton?: ButtonPresentationProps;
    successModal?: ModalPresentationProps;
    modalContainer?: GridContainerProps;
    messageTextGridItem?: GridItemProps;
    messageText?: TypographyPresentationProps;
    buttonGridItem?: GridItemProps;
    continueButton?: ButtonPresentationProps;
    // Starter Custom Code
    successBox?: InfosBoxProps;
}

export const contactFormStyles: ContactFormStyles = {
    container: {
        css: css`
            form {
                width: 100%;
            }
        `,
    },
    formGridItem: { width: 12 },
    successModal: { sizeVariant: "small" },
    successBox: {
        type: "success",
    },
};

const styles = contactFormStyles;
const emailsRegexp = new RegExp(
    "^[\\W]*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4}[\\W]*,{1}[\\W]*)*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4})[\\W]*$",
);

type Validator = () => boolean;
type ContextType = {
    validators: {
        [key: string]: Validator | undefined;
    };
};

export const ContactFormContext = React.createContext<ContextType>({
    validators: {},
});

const ContactForm = ({ id, fields, submitContactForm, clearForm, validateReCaptcha }: Props) => {
    // Store Custom Code
    const {
        emailRecipients,
        submitButtonText,
        successMessage,
        sizeVariant,
        successMessageType,
        variant,
        link,
        buttonAlignment,
    } = fields;

    // Store Custom Code
    const [validators] = useState<ContextType>({ validators: {} });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const recaptchaRef: RefObject<ReCAPTCHA> = React.createRef();
    // Store Custom Code
    const history = useHistory();
    const toaster = useToaster();
    const { url } = useGetLink(link);

    /* Starter Custom Code */
    const trackFormStart = ga.use.trackFormStart({ form_name: constants.contactUs.form_name });
    const trackFormSubmit = ga.use.trackFormSubmit({ form_name: constants.contactUs.form_name });
    const canTrackFormStartRef = useRef(true);
    const formRef = useRef<HTMLFormElement>(null);

    useEffect(() => {
        const handleFormFocus = () => {
            if (formRef.current?.contains(document.activeElement) && canTrackFormStartRef.current) {
                trackFormStart();
                canTrackFormStartRef.current = false;
            }
        };

        formRef.current?.addEventListener("focus", handleFormFocus, true);

        return () => {
            formRef.current?.removeEventListener("focus", handleFormFocus);
        };
    }, []);
    /* Starter Custom Code */

    const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const widgetValidators: Validator[] = [];
        Object.keys(validators).forEach(key => {
            const validator = validators.validators[key];
            if (validator) {
                widgetValidators.push(validator);
            }
        });
        const results = widgetValidators.map(v => v());
        if (!results.every(o => o)) {
            return;
        }

        const isReCaptchaValid = await validateReCaptcha({ location: "ContactUs", recaptchaRef });

        if (!isReCaptchaValid) {
            return;
        }

        setIsSubmitting(true);
        submitContactForm({
            emailRecipients,
            onSuccess: () => {
                // Store Custom Code - >
                if (successMessageType === "toast") {
                    toaster.addToast({ body: successMessage, messageType: "success" });
                    clearForm();
                }
                if (successMessageType === "modal") {
                    setIsModalOpen(true);
                }
                if (url) {
                    history.push(url);
                }
                // Store Custom Code

                setIsSubmitting(false);
                /* Starter Custom Code */
                trackFormSubmit();
                canTrackFormStartRef.current = true;
                /* Starter Custom Code */
            },
            onComplete() {
                // "this" is targeting the object being created, not the parent SFC
                // eslint-disable-next-line react/no-this-in-sfc
                this.onSuccess?.();
            },
        });
    };

    const modalCloseHandler = () => {
        setIsModalOpen(false);
        clearForm();
    };
    const formActionStyles: FormActionsStyles = {
        flexWrapper: {
            content: {
                css: css`
                    justify-content: ${buttonAlignment};
                `,
            },
        },
    };
    /* Starter Removed - continueButtonClickHandler */

    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.formGridItem}>
                <ContactFormContext.Provider value={validators}>
                    {/* Foundation - StoreFormWrapper */}
                    <FormWrapper>
                        <form
                            id="contactForm"
                            onSubmit={handleFormSubmit}
                            noValidate
                            ref={formRef} // Starter Custom Code
                        >
                            <Zone contentId={id} zoneName="Content" />
                            {/* Starter Removed - ReCaptcha */}
                            {/* Starter Custom Code */}
                            <FormActions extendedStyles={formActionStyles}>
                                <Button
                                    {...styles.submitButton}
                                    // Store Custom Code - >
                                    variant={variant}
                                    sizeVariant={sizeVariant}
                                    // Store Custom Code - <
                                    type="submit"
                                    disabled={isSubmitting}
                                >
                                    {submitButtonText}
                                </Button>
                            </FormActions>
                            <Modal
                                headline={translate("Message Sent")}
                                contentLabel={successMessage}
                                {...styles.successModal}
                                isOpen={isModalOpen}
                                handleClose={modalCloseHandler}
                            >
                                <InfosBox {...styles.successBox}>{successMessage}</InfosBox>
                                <FormActions>
                                    <Button {...styles.continueButton} onClick={modalCloseHandler}>
                                        {translate("Continue")}
                                    </Button>
                                </FormActions>
                            </Modal>
                            {/* Starter Custom Code */}
                        </form>
                    </FormWrapper>
                    {/* Foundation - StoreFormWrapper */}
                </ContactFormContext.Provider>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(ContactForm),
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
        fieldDefinitions: [
            // Store Custom Code - >
            { ...variantField.definition },
            { ...sizeVariantField.definition },
            {
                name: fields.buttonAlignment,
                displayName: "Button Alignment",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Left", value: "flex-start" },
                    { displayName: "Center", value: "center" },
                    { displayName: "Right", value: "flex-end" },
                ],
                defaultValue: "flex-start",
                fieldType: "General",
            },
            {
                name: fields.successMessageType,
                displayName: "Success Message Type",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Modal", value: "modal" },
                    { displayName: "Toast", value: "toast" },
                ],
                defaultValue: "modal",
                fieldType: "General",
            },
            {
                name: fields.link,
                displayName: "Button Link",
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
                fieldType: "General",
            },
            // Store Custom Code
            {
                name: fields.emailRecipients,
                displayName: "Email recipients",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "testaccount@insitesoft.com",
                isRequired: true,
                regularExpression: emailsRegexp,
            },
            {
                name: fields.submitButtonText,
                displayName: "Submit Button Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Send",
            },
            {
                name: fields.successMessage,
                displayName: "Submit Success Message",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                defaultValue: "Thank you for your inquiry. A customer service representative will contact you shortly.",
            },
        ],
    },
};

export default widgetModule;
